import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import PhotoBook1 from "../../assets/img/PhotoBook-5x5.jpg";
import PhotoBook2 from "../../assets/img/PhotoBook-6x8.jpg";
import PhotoBook3 from "../../assets/img/PhotoBook-8x6.jpg";
import PhotoBook4 from "../../assets/img/PhotoBook-8x8.jpg";
import PhotoBook5 from "../../assets/img/PhotoBook-8x8.jpg";
import PhotoBook6 from "../../assets/img/PhotoBook-8x10.jpg";
import PhotoBook7 from "../../assets/img/PhotoBook-8x11.jpg";
import PhotoBook8 from "../../assets/img/PhotoBook-8x8.jpg";
import Mix from "../../assets/img/mix.svg";
import One from "../../assets/img/one.svg";
import Two from "../../assets/img/two.svg";
import Three from "../../assets/img/three.svg";
import Four from "../../assets/img/four.svg";
import Forty from "../../assets/img/forty.svg";
import Sixty from "../../assets/img/sixty.svg";
import Eighty from "../../assets/img/eighty.svg";
import Info from "../../assets/img/info.svg";
import PageCountService from "../../Services/PageCountService";
import Header from "../../Components/Header";
import pageCountStore from "../../stores/PhotobookPageCountStore";



interface PageOption {
    pageId: number;
    numberOfPages: number;
    price: number;
  }
  const headerLinks = [{ name: "Home", href: "/" }];

export default function ChoosePageCount() {
    const [activeSection, setActiveSection] = useState(1);
    const [showButton, setShowButton] = useState(false);
    const [showBorder, setShowBorder] = useState(0);
    const [pageOptions, setPageOptions] = useState<PageOption[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();
    

    const handleRadioButton = (value: boolean, index: number) => {
        setShowButton(value);
        setShowBorder(index);
        
      };

      useEffect(() => {
        const fetchPageOptions = async () => {
          try {
            const options = await PageCountService.getPageCountOptions();
            setPageOptions(options);
          } catch (err) {
            setError('Failed to load page options');
          } finally {
            setLoading(false);
          }
        };
    
        fetchPageOptions();
      }, []);
      if (loading) return <div>Loading...</div>;
      if (error) return <div>{error}</div>;
      const imageMap: { [key: number]: string } = {
        3: Forty,
        4: Sixty, 
        5: Eighty, 
      };

      const handleStartPersonalize = (pageId: number, numberOfPages: number, price: number) => {
        pageCountStore.setChoosedCount(pageId, numberOfPages, price); 
        setTimeout(() => {
          navigate("/photobookeditor", { replace: true });
      }, 2000);
      };
 return (
    <><Header cartItemsCount={0} title="My Website" links={headerLinks} /><div>
         <section className="ChoosePageCount">
             <div className="mx-auto max-w-7xl mt-10 mb-40  px-4 sm:px-6 lg:px-8">
                 <h1 className="text-3xl font-normal text-left">
                     Choose Page Count
                 </h1>
                 <p className="text-lg text-gray-800 mt-3">How many pages would you like to start with?</p>
                 <p className="text-sm text-gray-600 mt-2"> You can add or remove pages once your project is created.</p>

                 <div className="flex justify-left mt-8">
                     {pageOptions.map((option, index) => (
                         <div
                             key={option.pageId}
                             className={(showBorder === option.pageId ? "border-slate-sel" : "") +
                                 " mr-4 block max-w-sm p-8 px-14 text-center border border-gray-200 rounded-lg shadow hover:bg-gray-100"}
                         >
                             <div className="flex flex-col items-center">
                                 <img
                                     src={option.numberOfPages === 40 ? Forty : option.numberOfPages === 60 ? Sixty : Eighty}
                                     alt={`Page option ${option.numberOfPages}`}
                                     className="h-20 w-auto" />
                                 <div className="mt-5 text-md font-bold">
                                     ${option.price.toFixed(2)}
                                 </div>
                                 <span className="mb-3 pt-1 text-sm font-medium text-gray-900">
                                     pages
                                 </span>
                                 <span className="pt-0">
                                     <input
                                         type="radio"
                                         className="h-5 w-5"
                                         name="productorientations"
                                         onClick={() => handleRadioButton(true, option.pageId)} />
                                 </span>
                             </div>
                         </div>
                     ))}
                 </div>

                 {showButton && (
                     <div className="flex justify-center">
                         <div className="mt-10 w-80">                            
                         <button
                type="submit"
                onClick={() => {
                  const selectedOption = pageOptions.find(option => option.pageId === showBorder);
                  if (selectedOption) {
                    handleStartPersonalize(
                      selectedOption.pageId,
                      selectedOption.numberOfPages,
                      selectedOption.price
                    );
                  }
                }}
                className="w-full uppercase py-2 px-4 bg-green font-medium text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
              >
                Start Personalize
              </button>
                         </div>
                     </div>
                 )}
             </div>
         </section>
     </div></>
  );
}